import { render, staticRenderFns } from "./NYTStrands.vue?vue&type=template&id=76046ff4&scoped=true"
import script from "./NYTStrands.js?vue&type=script&lang=js&external"
export * from "./NYTStrands.js?vue&type=script&lang=js&external"
import style0 from "./NYTStrands.scss?vue&type=style&index=0&id=76046ff4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76046ff4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NYTStrandsCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTStrandsCard/NYTStrandsCard.vue').default,NYTStrandsAccordionSection: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTStrandsAccordionSection/NYTStrandsAccordionSection.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
